/* tslint:disable */
/* eslint-disable */
/* Mocked in-memory implementation of DistrictsClient for local development and UI wiring. */

import { CancelToken } from 'axios';
import { SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfDistrict, District } from '../../types';

/* ---- Helper Functions ---- */

function delay(ms: number = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function successResponse<T>(data: T): { data: T; success: boolean; message: string } {
  return { data, success: true, message: 'Success' };
}

/* ---- Mock Data ---- */

const mockDistricts: District[] = [
  {
    id: 1,
    description: 'North Region',
    franchiseName: 'Demo',
    districtStores: [
      { key: 'STORE001', value: 'Store One' },
      { key: 'STORE002', value: 'Store Two' },
    ],
  },
  {
    id: 2,
    description: 'South Region',
    franchiseName: 'Demo',
    districtStores: [
      { key: 'STORE003', value: 'Store Three' },
      { key: 'STORE004', value: 'Store Four' },
    ],
  },
  {
    id: 3,
    description: 'East Region',
    franchiseName: 'Demo',
    districtStores: [
      { key: 'STORE005', value: 'Store Five' },
    ],
  },
];

/* ---- Mocked Client Implementation ---- */

import { IDistrictsClient } from '../../interfaces';
export class DistrictsClientMocked implements IDistrictsClient {
  constructor(baseUrl?: string) {}

  async districts(franchiseName?: string, cancelToken?: CancelToken): Promise<SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfDistrict> {
    await delay();
    const filtered = franchiseName
      ? mockDistricts.filter((d) => d.franchiseName === franchiseName)
      : mockDistricts;
    return successResponse(successResponse(filtered)) as SuccessResponse_1OfSuccessResponse_1OfIEnumerable_1OfDistrict;
  }

  // ====== Auto-generated stub methods ======


  // ====== Auto-generated stub methods ======

}
